import { useCallback } from 'react';

export default function usePdfSidebarNavigation({ setCurrentPage, pageRefs }) {
  const handleSidebarPageClick = useCallback((pageNum) => {
    setCurrentPage(pageNum);
    const pageContainer = pageRefs.current[pageNum];
    if (pageContainer) {
      pageContainer.scrollIntoView({ behavior: 'auto', block: 'start' });
    }
  }, [setCurrentPage, pageRefs]);

  return { handleSidebarPageClick };
}
